export const pricingData = [
    {
        title:'Basic',
        price:'10.99$ per user/month',
        numAcc:'max of 50 users',
        features:['Safe accounts', 'Easily setup', 'Affordable', 'Great for smaller businesses']
    },
    {
        title:'Standard',
        price:'15.99$ per user/month',
        numAcc:'51-100 users',
        features:['Tailored', 'Secure accounts', '1TB SSD', 'Advised for startups']
    },
    {
        title:'Premium',
        price:'25.99$ per user/month',
        numAcc:'100-500 users',
        features:['Secure accounts','Development team', 'reachable support', 'Instant integrations', 'customizable']
    },
    {
        title:'Entreprise',
        price:'35.99$ per user/month',
        numAcc:'Unlimited',
        features:['Unlimited storage', 'Scalability', 'Free DNS & Domain']
    }
]